import axios, { AxiosError, AxiosResponse } from 'axios';
import { API_BASE_URL } from '../common/constants/constants';
import { store } from '../store/store';
import JWTTokenService from '../common/service/JWTTokenService';
import { logOutUser, setCredentialsError, setTokens } from '../store/slice/KorisnikSlice';

const axiosApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    contentType: 'application/json, multipart/form-data',
    // 'Access-Control-Allow-Origin': '*',
    Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
    // Authorization:
    //   'Bearer ' +
    //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjk0MDgzNjg3LCJpYXQiOjE2OTQwNzY0ODcsImp0aSI6IjQ0ZWNkZWNmMGU3NzRhNTZiZDRjNDYzNTJmNmUxM2ViIiwidXNlcl9pZCI6MX0.xqy0Lc17RSgSJakH2JZAXlQx5CZSQrnL75LBsO-Iw5s',
    withCredentials: true,
  },
});

axiosApi.interceptors.response.use(
  (response: AxiosResponse) => {
    return Promise.resolve(response);
  },
  (error: AxiosError) => {
    const accessToken = store.getState().korisnik.accessToken;
    const refreshToken = store.getState().korisnik.refreshToken;

    if (accessToken !== null && refreshToken !== null) {
      if (error.config && error.response && error.response.status === 401) {
        if (error.config.headers.Authorization !== 'Bearer ' + accessToken) {
          error.config.headers.Authorization = 'Bearer ' + accessToken;

          return axios.request(error.config);
        } else {
          let failedRequest = error.config;

          return JWTTokenService.refreshToken(accessToken, refreshToken)
            .then((response) => {
              store.dispatch(setTokens(response.data.access));

              axiosApi.defaults.headers['Authorization'] = 'Bearer ' + response.data.access;

              failedRequest.headers.Authorization = 'Bearer ' + response.data.access;

              return axios.request(failedRequest);
            })
            .catch((error) => {
              if (!error.response || error.response.status === 403) {
                store.dispatch(setCredentialsError(error?.response?.data?.error?.errorMessage || 'Potrebno je ponovno izvršiti prijavu.'));
                store.dispatch(logOutUser());
                // JWTTokenService.logout();
              }
              return Promise.reject(error);
            });
        }
      } else if (!error.response) {
        store.dispatch(logOutUser());
      }
    }
    return Promise.reject(error);
  }
);

export default axiosApi;
